import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../firebaseConfig' // ваш конфиг
import { useNavigate } from 'react-router-dom'

import {
	TextField,
	Button,
	Typography,
	Link,
	Paper,
	Container,
	Alert,
	CircularProgress
} from '@mui/material'
import logger from '../utils/logger'

function ForgotPassword() {
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [error, setError] = useState('')
	const [message, setMessage] = useState('')
	const [loading, setLoading] = useState(false)

	

	const handleReset = async e => {
		e.preventDefault()
		setError('')
		setMessage('')
		setLoading(true)
		try {
			await sendPasswordResetEmail(auth, email, {
				url: 'http://localhost:5173/login', // или ваш production URL
			})
			
		} catch (err) {
			logger.error(err)
			setError(err.message)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Container component='main' maxWidth='xs'>
			<Paper elevation={3} style={{ padding: 20, marginTop: 40 }}>
				<Typography variant='h5' style={{ marginBottom: 20 }}>
					{'Восстановить пароль'}
				</Typography>
				{error && (
					<Alert severity='error' style={{ marginBottom: 20 }}>
						{error}
					</Alert>
				)}
				{message && (
					<Alert severity='success' style={{ marginBottom: 20 }}>
						{message}
					</Alert>
				)}
				<form onSubmit={handleReset}>
					<TextField
						variant='outlined'
						margin='normal'
						required
						fullWidth
						label={'Email'}
						autoComplete='email'
						size='small'
						value={email}
						onChange={e => setEmail(e.target.value)}
						disabled={loading}
					/>
					<Button
						type='submit'
						fullWidth
						variant='contained'
						color='primary'
						style={{ margin: '24px 0 16px' }}
						disabled={loading}
					>
						{'Отправить письмо'}
					</Button>
				</form>
				<Button
					fullWidth
					variant='outlined'
					color='primary'
					onClick={() => navigate('/login')}
					disabled={loading}
				>
					{'На страницу логина'}
				</Button>
			</Paper>
		</Container>
	)
}

export default observer(ForgotPassword)
